<template>
  <div class="ranking">
    <div class="title">排名</div>
    <div
      v-for="(item, index) in rankingList"
      :key="index"
      class="r-item"
      @click="rankingClick(item)"
    >
      <div>{{ index + 1 }}、{{ item.title }}</div>
      <div>{{ item.views }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RankingBox",
  components: {},
  props: {
    rankingList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    rankingClick(item) {
      const pageId = this.$route.query.id;
      if(!item.id && !this.$route.path.includes(item.path)) this.$router.push(item.path)
      if (item.id == pageId) return;
      this.$router.push({
        path: item.path,
        query: { id: item.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking {
  height: 100%;
  width: 450px;
  padding: 20px;
  position: absolute;
  right: 0;
  top: 0;
  .title {
    vertical-align: top;
    letter-spacing: 0;
    font-size: 24px;
    color: #18191e;
    margin-bottom: 20px;
  }
  .r-item {
    font-size: 18px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }
}
</style>